import { useMuiModalContext } from '@modules/common/components/Modal/ModalContext';
import { useAreLabelInterestsAvailable } from '@modules/feed/hooks';
import { SettingsSuggestRounded } from '@mui/icons-material';
import { Box, Button, Paper, Stack, Typography } from '@mui/material';
import { StatusEmailModal } from 'modules/ui/Profile/StatusEmailPreferences/StatusEmailModal';

interface AddLabelInterestsBannerProps {
  onUpdate: () => void;
}

export function AddLabelInterestsBanner({
  onUpdate,
}: AddLabelInterestsBannerProps) {
  const { openModal, closeModal } = useMuiModalContext();
  const { loading, areLabelInterestsAvailble } =
    useAreLabelInterestsAvailable();

  function openStatusEmailModal() {
    openModal({
      contentComponent: () => {
        return (
          <StatusEmailModal
            isModalOpen={true}
            setModalOpen={() => {
              closeModal();
              onUpdate();
            }}
          />
        );
      },
      modalProps: {},
    });
  }

  if (loading) {
    return null;
  }

  if (areLabelInterestsAvailble) {
    return (
      // Box required to avoid overriding of Stack margin
      <Box>
        <Stack
          direction="row"
          spacing={1.5}
          alignItems="center"
          justifyContent="flex-end"
        >
          <Typography variant="subtitle2">
            Want better recommendations?
          </Typography>
          <Button
            color="primary"
            variant="text"
            size="small"
            onClick={openStatusEmailModal}
            startIcon={<SettingsSuggestRounded />}
          >
            Update Interests
          </Button>
        </Stack>
      </Box>
    );
  }

  return (
    <Stack direction="row" justifyContent="center">
      <Stack
        component={Paper}
        variant="outlined"
        direction="row"
        spacing={3}
        alignItems="center"
        sx={{
          borderRadius: 2,
          px: 3,
          py: 1.5,
        }}
      >
        <Typography variant="subtitle1">
          🌟 Want customized recommendations of Tracked Keywords and Reasons?
        </Typography>
        <Button
          variant="outlined"
          startIcon={<SettingsSuggestRounded />}
          onClick={openStatusEmailModal}
        >
          ADD YOUR INTERESTS
        </Button>
      </Stack>
    </Stack>
  );
}
